<template>
    <span>
      {{timeAgo}}
    </span>
</template>

<script>
import parse from 'date-fns/parse'
import distanceInWords from 'date-fns/distance_in_words'

export default {
  props: {
    time: {
      type: String
    }
  },

  data: function () {
    return {}
  },

  computed: {
    date: function () {
      return parse(this.time)
    },

    timeAgo: function () {
      if (this.time === null) {
        return '—'
      } else {
        return distanceInWords(Date.now(), this.date) + ' ago'
      }
    }
  }
}
</script>
